import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * User Module Service Stores
 */
export const userStores: ServiceStoreConfig[] = [
  {
    name: "users",
    // rootStore key stays `usersStore`; the NTX API registers the service at
    // the singular `user` path (services/users/users.ts → userPath = 'user').
    servicePath: "user",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "id",
    },
  },
];